<template>
  <div class="position-relative">
    <vue-dropzone
      id="dropzone"
      ref="myVueDropzone"
      :options="dropzoneOptions"
      @vdropzone-removed-file="removeThisFile"
      @vdropzone-success="onImageSelected"
    />
    <div class="drop-icon" @click="openDropzone">
      <feather-icon
        class="drop-icon-camera"
        icon="CameraIcon"
        size="20"
      />
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'
import { config } from '@/shared/app.config'

export default {
  name: 'ImageDropzone',
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    files: {
      type: Array,
    },
    maxFiles: {
      type: String,
    },
    label: {
      type: String,
      default: 'Añadir foto de perfil',
    },
    typeFile: {
      required: false,
    },
  },
  data() {
    let confMaxfiles = 1
    if (this.maxFiles) {
      confMaxfiles = this.maxFiles
    }
    const availableTypefiles = (this.typeFile) ? this.typeFile : 'image/*,application/pdf,.psd, text/csv, .rfa, .ifc, .zip'
    return {
      file: '',
      template: `
                <div class="dz-preview dz-file-preview">
                  <div class="dz-details">
                    <div class="dz-filename"><span data-dz-name></span></div>
                    <div class="dz-size" data-dz-size></div>
                    <img data-dz-thumbnail />
                  </div>
                  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                  <div class="dz-success-mark"><span>✔</span></div>
                  <div class="dz-error-mark"><span>✘</span></div>
                  <div class="dz-error-message"><span data-dz-errormessage></span></div>
                </div>
            `,
      // https://www.dropzonejs.com/#configuration-options
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        paramName: 'myFile',
        thumbnailWidth: 200,
        maxFilesize: 20,
        maxFiles: confMaxfiles,
        acceptedFiles: availableTypefiles,
        dictDefaultMessage:
            `${'<div class="dz-message-default">Arrasta archivos</div>'
            + '<div class="dz-message-image" hidden>'
            + '<svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>'
            + '<div class="mt-1">'}${
              this.label
            }</div>`
            + '</div>',
        dictFileTooBig: 'Archivo demasiado grande ({{filesize}}MiB). Tamaño máximo: {{maxFilesize}}MiB.',
        wasQueueAutoProcess: true,
        autoQueue: true,
        addRemoveLinks: true,
        dictRemoveFile: 'Eliminar',
        // previewTemplate: this.template
      },
    }
  },
  mounted() {
    const elementVue = this.$refs.myVueDropzone

    if (this.files) {
      this.files.forEach(element => {
        // Manejar tanto .url como .path
        const fileUrl = element.url || element.path

        // Cargar la imagen como blob y convertirla a base64
        this.loadImageAsBase64(fileUrl, element.name).then(base64Data => {
          const file = {
            name: element.name,
            type: 'image/png',
            dataURL: base64Data,
            urlDelete: element.urlDelete,
            width: 200,
            height: 200,
          }

          elementVue.manuallyAddFile(file, base64Data)
          elementVue.dropzone.emit('thumbnail', file, base64Data)
          elementVue.dropzone.emit('complete', file)
        }).catch(error => {
          console.error('Error al cargar imagen:', error)
        })
      })
    }
  },
  methods: {
    openDropzone() {
      try {
        const dropzone = this.$refs.myVueDropzone
        if (dropzone && dropzone.dropzone && dropzone.dropzone.hiddenFileInput) {
          // Usar el input oculto del dropzone
          dropzone.dropzone.hiddenFileInput.click()
        } else {
          // Alternativa: buscar el input directamente
          const fileInput = this.$el.querySelector('input[type="file"]')
          if (fileInput) {
            fileInput.click()
          }
        }
      } catch (error) {
        console.error('Error al abrir el dropzone:', error)
      }
    },
    async loadImageAsBase64(imageUrl, imageName) {
      try {
        const response = await axios.get(imageUrl, {
          responseType: 'blob',
        })

        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => {
            resolve(reader.result)
          }
          reader.onerror = reject
          reader.readAsDataURL(response.data)
        })
      } catch (error) {
        console.error(`Error al cargar imagen: ${imageName}`, error)
        throw error
      }
    },
    hasFilesRejected() {
      return this.$refs.myVueDropzone.getRejectedFiles().length > 0
    },
    emptyDropzone() {
      const elementVue = this.$refs.myVueDropzone
      elementVue.removeAllFiles()
    },
    removeThisFile(file) {
      if (file.urlDelete) {
        const thisVs = this.$vs
        if (this.$refs.myVueDropzone.dropzone.disabled !== true) {
          axios
            .delete(`${config.webApiBase}${file.urlDelete}`)
            .then(() => {
              thisVs.notify({
                title: 'Imagen borrada',
                text: '',
                color: 'success',
                position: 'top-right',
              })
            })
            .catch(() => {
              thisVs.notify({
                title: 'No ha sido posible eliminar la imagen',
                text: 'Error',
                color: 'danger',
                position: 'top-right',
              })
            })
        }
      }
    },
    submitFiles() {
      // let files = this.files;
      const rejectedFiles = this.$refs.myVueDropzone.getRejectedFiles()

      if (this.hasFilesRejected()) {
        console.log('FILES REJECT', rejectedFiles)
      }

      const formData = this.getFormData()
      // 'https://httpbin.org/post'
      const thisVs = this.$vs
      axios
        .post(`${config.webApiBase}/app/attachment`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          thisVs.notify({
            title: 'Imagen subida',
            text: ':)',
            color: 'success',
            position: 'top-right',
          })
        })
        .catch(() => {
          thisVs.notify({
            title: 'No ha sido posible subir la imagen',
            text: '',
            color: 'danger',
            position: 'top-right',
          })
        })
    },
    getFormData(nameOption = 'myFile', formData = new FormData()) {
      const files = this.getFiles()

      for (let i = 0; i < files.length; i++) {
        const file = files[i]

        formData.append(`${nameOption}[${i}]`, file)
      }

      return formData
    },
    getFiles() {
      return this.$refs.myVueDropzone.getAcceptedFiles()
    },
    onImageSelected(file, response) {
      const image = {
        name: file.name,
        type: file.type,
        dataURL: file.dataURL,
      }
      this.$emit('image-selected', image)
    },
    destroyed() {
      this.$store.commit("users/setUser", {});
    },
  },
}
</script>

<style>
.dropzone .dz-preview .dz-image {
  width: 200px !important;
  height: 200px !important;
}

.dropzone .dz-preview .dz-image img {
  max-width: 200px;
  padding: 25px;
}

.dropzone .dz-preview .dz-details .dz-size {
  display: none !important;
}
</style>
